<template>
	<el-dialog ref='imgdialog' title='图片裁剪' class='avatar-dialog' @close='close()' :visible.sync='dialogVisible'
		:close-on-click-modal='false' width='600px' append-to-body>
		<div class='avatar-main'>
			<div class='avatar-main-box'>
				<vue-cropper class='cropper-box lineBlock' ref='cropper' :guides='true' :view-mode='0'
					:aspect-ratio='aRation' :auto-crop-area='1' :background='true' :rotatable='true' :responsive='true'
					:zoomable='true' :zoom-on-touch='true' :zoom-on-wheel='true' alt='图片加载中 。。' :center='true'
					:src='cropLawImg' :ready='readyCropImage' :zoom='cropImage' :cropmove='cropImage'
					:cropend='cropImage' :crop-box-resizable='true'>
				</vue-cropper>
			</div>
		</div>
		<div class='avatar-tool'>
			<div class='avatar-hint'>
				<p>我们建议图片控制在300k以内，否则用户访问速度很慢。</p>
				<p>
					宽： <span>{{cropOptions.wSize}}</span>
					高： <span>{{cropOptions.hSize}}</span>
				</p>
			</div>
			<div class='avatar-tool-right'>
				<i class='iconfont icon-icon-gyrate' title='逆时针旋转90度' @click='rotateCrop'></i>
				<img src='../../../../assets/images/huanyuanpingmudaxiao.png' title='返回初始大小' @click='resetCrop' />
				<i class='iconfont icon-iconjia' title='放大' @click='zoom(0.1)'></i>
				<i class='iconfont icon-jianhao' title='缩小' @click='zoom(-0.1)'></i>
			</div>
		</div>
		<yq-loading-mask :config='loadingConfig'></yq-loading-mask>
		<span slot='footer' class='dialog-footer'>
			<el-button type='warning' @click='saveCrop' round>确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
import VueCropper from 'vue-cropperjs'
import { mapState, mapActions } from 'vuex'
import Utils from '@/utils/utils.js'
export default {
	name: 'imgCropper',
	components: {
		VueCropper
	},
	props: ['showCropper', 'cropOptions', 'aRation', 'newFileName'],
	created() {
		this.dialogVisible = this.showCropper
	},
	computed: {
		...mapState(['globals']),
		...mapState('template', ['bannerOriginSize', 'indexPageId', 'projId'])
	},
	data() {
		return {
			dialogVisible: false,
			cropLawImg: this.cropOptions.cropLawImg,
			loadingConfig: {
				show: false,
				info: '拼命加载中'
			},
			isCropper: false
		}
	},
	methods: {
		...mapActions('qiniu', ['uploadFile']),
		...mapActions('template', ['uploadImgByUrl']),
		/**
		 * 裁切框打开一秒后关闭loading
		 */
		closeLoading() {
			setTimeout(() => {
				this.loadingConfig.show = false
			}, 1000)
		},
		cropImage() {
			this.isCropper = true
			this.initCrop()
		},
		readyCropImage() {
			this.initCrop()
		},
		initCrop() {
			if (this.cropOptions.isScale || this.cropOptions.islogo) {
				let imgData = this.$refs.cropper.getData()
				this.cropOptions.wSize = Number.parseInt(imgData.width)
				this.cropOptions.hSize = Number.parseInt(imgData.height)
			}
		},
		saveCrop() {
			if (this.loadingConfig.show) return
			this.loadingConfig.show = true
			if (!this.isCropper && this.cropOptions.originImgUrl) {
				this.uploadCmsImg()
			} else {
				this.cropEnd()
			}
		},
		async uploadCmsImg() {
			let imgUrl = this.cropOptions.originImgUrl
			let extName = imgUrl.split('.')[imgUrl.split('.').length - 1]
			let imgKey = this.projId + '/' + this.indexPageId + '/images/' + Utils.getNewFileName(7) + '.' + extName
			let params = {
				key: imgKey,
				imgUrl: imgUrl
			}
			let { data } = await this.uploadImgByUrl(params)
			this.loadingConfig.show = false
			if (data.isSuccess) {
				this.$emit('closeCrop', this.globals.basImagePath + data.data)
			} else {
				console.log('上传七牛失败')
			}
		},
		cropEnd() {
			this.toBlob().then( res => {
				let cropSrc = this.globals.basImagePath + res.key
				// 图片压缩
				if ( this.cropOptions.islogo && res.imgQuality / 1024 > 30 && (res.type === 'image/jpeg' || res.type === 'image/png')) {
					// logo大于30k压缩
					cropSrc += '?imageslim'
				} else if (
					res.imgQuality / 1024 > 500 && (res.type === 'image/jpeg' || res.type === 'image/png')
				) {
					cropSrc += '?imageslim'
				}
				this.$emit('closeCrop', cropSrc)
				this.loadingConfig.show = false
				this.dialogVisible = false
			},
			err => {
				console.log(err)
				this.loadingConfig.show = false
				this.$message.error('上传图片失败')
			}
			)
		},
		toBlob() {
			return new Promise((resolve, reject) => {
				// 图片补白
				let params = {
					fillColor: '#fff',
					imageSmoothingQuality: 'high',
					width: this.cropOptions.wSize,
					height: this.cropOptions.hSize
				}
				// 文章页图片的最大宽度1200
				if (this.cropOptions.isScale) {
					params.width = params.width > 1200 ? 1200 : this.cropOptions.wSize
				}
				// logo最大宽高 300*300
				if (this.cropOptions.islogo) {
					params.maxWidth = 300
					params.maxHeight = 300
				}
				if (this.bannerOriginSize) {
					let sizeObj = this.bannerOriginSize.split('×')
					params.width = sizeObj[0]
					params.height = sizeObj[1]
				}
				let canvas = this.$refs.cropper.getCroppedCanvas(params)
				let blob = this.base64ToBlob(canvas)
				let blobInfo = {
					imgQuality: blob.size,
					type: blob.type
				}
				this.uploadFile({ file: blob, fileName: this.newFileName, fname: this.cropOptions.fname }).then( res => {
					res = Object.assign(res, blobInfo)
					resolve(res)
				}, err => {
					reject(err)
				})
			})
		},
		base64ToBlob(canvas) {
			let type = this.cropLawImg.match(/image\/[a-z]+/)[0]
			let base64 = canvas.toDataURL(type)
			let binStr = atob(base64.split(',')[1]) // atob兼容ie10以上
			let len = binStr.length
			let arr = new Uint8Array(len)
			for (let i = 0; i < len; i++) {
				arr[i] = binStr.charCodeAt(i)
			}
			return new Blob([arr], {
				type
			})
		},
		close() {
			this.$emit('closeCrop')
			this.dialogVisible = false
		},
		rotateCrop() {
			this.isCropper = true
			this.$refs.cropper.rotate(-90)
		},
		resetCrop() {
			this.isCropper = false
			this.$refs.cropper.reset()
		},
		zoom(radio) {
			this.isCropper = true
			this.$refs.cropper.relativeZoom(radio)
		}
	}
}

</script>
<style lang='scss' scoped>
.avatar-dialog {
	.avatar-main {
		padding: 10px;
		border: 1px solid #aaa;
		width: 540px;
		height: 310px;
		background-image: url('../../../../assets/images/base-bg.jpg');
		background-clip: content-box;

		.avatar-main-box {
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			overflow: hidden;

			.cropper-box {
				max-width: 518px !important;
				max-height: 288px !important;
			}

			.cropper-container {
				max-width: 518px !important;
				max-height: 288px !important;

				.cropper-wrap-box {
					max-width: 518px !important;
					max-height: 288px !important;

					.cropper-canvas {
						max-width: 518px !important;
						max-height: 288px !important;

						img {
							max-width: 518px !important;
							max-height: 288px !important;
						}
					}
				}
			}
		}
	}

	.avatar-tool {
		border: 1px solid #aaa;
		border-top: 0;
		width: 100%;
		height: 50px;
		display: flex;
		padding: 0 10px;
		align-items: center;
		justify-content: space-between;

		.avatar-hint {
			width: 360px;

			p {
				text-align: left;
				color: #aaa;

				span {
					padding: 0 10px;
				}
			}
		}

		.avatar-tool-right {
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 110px;

			i {
				cursor: pointer;
				font-size: 18px;
			}

			img {
				width: 18px;
				cursor: pointer;
			}
		}
	}
}

</style>
